var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.95236 1.28569C7.95236 1.81168 7.52597 2.23807 6.99998 2.23807C6.474 2.23807 6.0476 1.81168 6.0476 1.28569C6.0476 0.759708 6.474 0.333313 6.99998 0.333313C7.52597 0.333313 7.95236 0.759708 7.95236 1.28569ZM7.05924 5.29145L2.93443 1.16665L1.09595 3.00512L5.22076 7.12993L1.16664 11.184L3.00512 13.0225L7.05923 8.96841L11.1133 13.0225L12.9518 11.184L8.89771 7.12993L13.0225 3.00518L11.184 1.1667L7.05924 5.29145ZM6.99998 13.9047C7.52597 13.9047 7.95236 13.4783 7.95236 12.9524C7.95236 12.4264 7.52597 12 6.99998 12C6.474 12 6.0476 12.4264 6.0476 12.9524C6.0476 13.4783 6.474 13.9047 6.99998 13.9047ZM12.7143 8.07141C12.1883 8.07141 11.7619 7.64501 11.7619 7.11903C11.7619 6.59304 12.1883 6.16665 12.7143 6.16665C13.2402 6.16665 13.6666 6.59304 13.6666 7.11903C13.6666 7.64501 13.2402 8.07141 12.7143 8.07141ZM0.333306 7.11903C0.333306 7.64501 0.759701 8.07141 1.28569 8.07141C1.81167 8.07141 2.23807 7.64501 2.23807 7.11903C2.23807 6.59304 1.81167 6.16665 1.28569 6.16665C0.759701 6.16665 0.333306 6.59304 0.333306 7.11903Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotes);
export default __webpack_public_path__ + "static/media/IconNotes.9ccecde2.svg";
export { ForwardRef as ReactComponent };